module.exports = __webpack_public_path__ + "static/media/platform-slider.051dd1c5.jpg";